import React, { useCallback, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import KlarnaPlacemanet from "./klarna-placemanet";
import PaypalPlacemanet from "./paypal-placement";
import classNames from "classnames";
import klarnaLogo from "../images/klarna_logo.png";
import PaypalLogo from "../icons/paypal-logo.svg";
import FindomesticLogo from "../icons/findomestic-logo.svg";
import { eventInternalLinkClick } from "../utility/datalayer";

const KLARNA_CLIENT_ID = process.env.GATSBY_KLARNA_CLIENT_ID;
const KLARNA_ENVIROMENT = process.env.GATSBY_KLARNA_ENVIROMENT;
const PAYPAL_CLIENT_ID = process.env.GATSBY_PAYPAL_CLIENT_ID;

const PaymentElement = ({ payment, sellingPrice }) => {
  switch (payment) {
    case "Klarna":
      return KLARNA_CLIENT_ID ? (
        <KlarnaPlacemanet
          clientId={KLARNA_CLIENT_ID}
          sellingPrice={sellingPrice * 100}
          enviroment={KLARNA_ENVIROMENT}
        />
      ) : null;
    case "Findomestic":
      return null;
    case "Paypal":
      return PAYPAL_CLIENT_ID ? (
        <PaypalPlacemanet
          clientId={PAYPAL_CLIENT_ID}
          sellingPrice={parseFloat(sellingPrice.toString().replace(",", "."))}
        />
      ) : null;
    default:
      return null;
  }
};

const PaymentIcon = ({ payment }) => {
  switch (payment) {
    case "Klarna":
      return <img src={klarnaLogo} className="payment-methods__image" alt="klarna-logo" />;
    case "Findomestic":
      return <FindomesticLogo />;
    case "Paypal":
      return <PaypalLogo />;
    default:
      return null;
  }
};

const PaymentMethods = ({ sellingPrice, pagePath }) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = useCallback(() => setOpen((value) => !value), []);

  const { config, labelManagerLabels } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        evidencePayment
        hiddenPayment
      }
      labelManagerLabels {
        morePaymentOptions
        lessPaymentOptions
      }
    }
  `);

  const evidencePayment = !!config?.evidencePayment ? config.evidencePayment?.slice(0, 2) : null;

  const hiddenPayment = !!config?.hiddenPayment
    ? config.hiddenPayment
        ?.filter((payment) => !config?.evidencePayment?.includes(payment))
        ?.slice(0, 2)
    : null;

  const onClickPaymentMethod = useCallback(() => {
    eventInternalLinkClick({
      click_element: "pdp_payment_method",
      action: !open ? "pdp_open" : "pdp_close",
      slug: pagePath,
    });
  }, [open, pagePath]);

  return (
    <>
      {evidencePayment?.length > 0
        ? evidencePayment?.map((element, i) => (
            <PaymentElement key={i} payment={element} sellingPrice={sellingPrice} />
          ))
        : null}
      {hiddenPayment?.length > 0 ? (
        <>
          <div className={`payment-methods__accordion${open ? " open" : ""}`}>
            {hiddenPayment?.map((element, index) => (
              <PaymentElement key={index} payment={element} sellingPrice={sellingPrice} />
            ))}
          </div>
          <button
            className={classNames("payment-methods__toggle", open && "open")}
            onClick={() => {
              toggleOpen();
              onClickPaymentMethod();
            }}
          >
            <span className={classNames("payment-methods__icons", open && "open")}>
              {hiddenPayment?.map((element, j) => (
                <PaymentIcon key={j} payment={element} />
              ))}
            </span>
            <span className="payment-methods__more">
              <span className={open ? "d-none" : "d-inline"}>
                {labelManagerLabels.morePaymentOptions}
              </span>
              <span className={open ? "d-inline payment-methods__more--icon-rotate" : "d-none"}>
                {labelManagerLabels.lessPaymentOptions}
              </span>
            </span>
          </button>
        </>
      ) : null}
    </>
  );
};

export default PaymentMethods;
